var render = function render(_c,_vm){return _c('div',{staticClass:"fflag flex-shrink-0",class:['fflag-' + _vm.props.country, 'ff-' + _vm.props.size, _vm.props.border ? 'border' : '', {'ff-round': _vm.props.round, 'ff-app': _vm.props.app, 'rounded-sm': _vm.props.rounded}]})
}
var staticRenderFns = []

export { render, staticRenderFns }